import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d76bb192&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d76bb192')) {
      api.createRecord('d76bb192', component.options)
    } else {
      api.reload('d76bb192', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d76bb192&", function () {
      api.rerender('d76bb192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu1/index.vue"
export default component.exports